import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Tooltip,
    Box,
} from "@mui/material";
import { Tree } from "react-organizational-chart";
import { TreeNode } from "react-organizational-chart";

const ArbolEmpleado = ({ organigrama }) => {
    const [root, setRoot] = useState(null);

    useEffect(() => {
        if (organigrama) {
            setRoot(organigrama);
        } else {
            setRoot(null);
        }
    }, [organigrama]);
    console.log(organigrama);

    const renderNode = (node) => {

        if (!node || !node.children) {
            return null;
        } else {
            console.log(node);
        }

        return (
            <>
                {/* Mapea directamente TreeNode por cada hijo en node.children */}
                {node.children.map((child) => (
                    <TreeNode
                        key={node.unidadSuperiorValue}
                        style={{ justifyContent: "center" }}
                        label={
                            <div style={{ textAlign: "center" }}>
                                <Grid container direction="column" alignItems="center">
                                    <Card
                                        sx={{
                                            maxWidth: "400px",
                                            margin: "8px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <CardContent>
                                            <Typography variant="subtitle2" sx={{ mt: 1 }}>
                                                {child.new_numerolegajo}
                                            </Typography>
                                            <Typography variant="subtitle1" sx={{ mt: 1 }}>
                                                {child.new_name}
                                            </Typography>
                                            <Tooltip title={child["_new_posicin_value@OData.Community.Display.V1.FormattedValue"]} arrow>
                                                <Typography variant="subtitle2" sx={{ mt: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                    {child["_new_posicin_value@OData.Community.Display.V1.FormattedValue"]}
                                                </Typography>
                                            </Tooltip>
                                            {/* Agrega verificación para otras propiedades si es necesario */}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </div>
                        }
                    >
                        {renderNode(child)}
                    </TreeNode>
                ))}
            </>
        );
    };

    return (

            <Tree
                lineColor="#ccc"
                lineWidth="2px"
                style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {root ? renderNode(root) : null}
            </Tree>
    )
}

export default ArbolEmpleado